export default "__VITE_ASSET__CiaSsvHB__"